import React from "react";

const Input = ({ value, type="text", onChange, placeholder="", className="", containerClassName="", error, showError=false, fullWidth=false, disabled=false }) => {
  return (
    <div className={`${fullWidth ? "w-full" : "inline-flex"} flex-col items-start ${containerClassName}`}>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className={`editable-field ${className} ${error && 'error'}`}
        disabled={disabled}
      />
      {showError && error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  )
}

export default Input;